import { UserStore } from '@/store/user';
import { raykouApi } from '@utils/axios';

export interface Plan extends Record<string, unknown> {
  description: string;
  name: string;
  price?: number;
  image: string;
}

const { user } = UserStore.getState();

export const getPlans = async () => {
  try {
    if (!user || !user.companySelected || !user.companySelected.id)
      throw new Error('company id is undefined');
    const res = await raykouApi.get('/plans/company', {
      headers: {
        company: user.companySelected.id,
      },
    });

    return res.data;
  } catch (error) {
    console.log(error);

    return [];
  }
};

export const savePlan = async (plan: Plan) => {
  try {
    if (!user || !user.companySelected || !user.companySelected.id)
      throw new Error('company id is undefined');

    await raykouApi.post('/plans', {
      ...plan,
      company: user.companySelected.id,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getOnePlan = (uid: string) => async () => (await raykouApi.get(`/plans/${uid}`)).data;

export const editPlan = (uid: string) => async (plan: Partial<Plan>) =>
  (await raykouApi.put(`/plans/${uid}`, plan)).data.data;

export const deletePlan = async (uid: string) =>
  (await raykouApi.delete(`/plans/${uid}`)).data.data;
